<template>
  <div id="wording">
    <v-container grid-list-xl>
      <v-layout align-center row wrap>
        <v-flex sm4 xs12>
          <div class="headline">Wording</div>
        </v-flex>
        <v-flex sm3 xs6>
          <!-- <v-autocomplete
            :items="users"
            clearable
            item-text="phone"
            item-value="phone"
            label="User"
            v-model="searchPhone"
          ></v-autocomplete>-->
        </v-flex>
        <v-flex sm3 xs6>
          <!-- <v-autocomplete
            :items="consultingTopics"
            clearable
            item-text="name"
            item-value="name"
            label="Topic"
            v-model="searchTopic"
          ></v-autocomplete>-->
        </v-flex>

        <v-flex sm2 text-xs-center xs12>
          <WordingDialog></WordingDialog>
        </v-flex>
        <v-flex xs12>
          <!-- Data Table -->
          <v-data-table
            :headers="headers"
            :items="states"
            :loading="tableLoading"
            class="elevation-0"
            disable-initial-sort
            hide-actions
          >
            <template slot="items" slot-scope="props">
              <tr @click="editItem(props.item.idx)">
                <td>{{ props.item.idx }}</td>
                <td>{{ filterWordingTypeName(props.item.wordingTypeId) }}</td>
                <td>{{ props.item.wordingText }}</td>
                <td>{{ filterCategorieTypeName(props.item.categorieTypeId) }}</td>
                <td>{{ filterPageName(props.item.pageId) }}</td>
                <td>{{ filterRegionName(props.item.regionId) }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'

import WordingDialog from '@/components/admin/WordingDialog'
export default {
  name: 'wording',
  components: {
    WordingDialog
  },
  data() {
    return {
      users: [],
      searchPhone: '',
      searchTopic: '',
      // Table
      tableLoading: false,
      headers: [
        { text: 'ID', align: 'left', value: 'idx', width: '10' },
        { text: 'Wording Type', align: 'left', value: 'wordingTypeId', width: '300' },
        { text: 'Text', align: 'left', value: 'wordingText', width: '300' },
        { text: 'Categorie Type', align: 'left', value: 'categorieTypeId', width: '300' },
        { text: 'Page', align: 'left', value: 'pageId', width: '300' },
        { text: 'Region', align: 'left', value: 'regionId', width: '300' }
      ]
    }
  },
  beforeRouteEnter: (to, from, next) => {
    store.state.Wording.data.length === 0 // main fetch
      ? store.dispatch('Wording/fetch').then(next())
      : next()

    if (store.state.WordingType.data.length === 0) store.dispatch('WordingType/fetch')
    if (store.state.Types.data.length === 0) store.dispatch('Types/fetch')
    if (store.state.Pages.data.length === 0) store.dispatch('Pages/fetch')
  },
  computed: {
    states() {
      return this.$store.getters['Wording/getAll']
    },
    wordingTypes() {
      return this.$store.getters['WordingType/getAll']
    },
    categorieTypes() {
      return this.$store.getters['Types/getAll'].filter(item => item.orders == 0)
    },
    pages() {
      return this.$store.getters['Pages/getAll']
    },
    regions() {
      return this.$store.getters['Place/getRegionAll']
    }
  },
  created() {},
  methods: {
    editItem(idx) {
      this.$store.commit('Wording/UPDATE_DIALOG', true)
      this.$store.commit('Wording/SET_IDX', idx)
    },
    filterWordingTypeName(wordingTypeId) {
      return this.wordingTypes
        .filter(item => item.idx == wordingTypeId)
        .map(item => item.name)
        .toString()
    },
    filterCategorieTypeName(categorieTypeId) {
      return this.categorieTypes
        .filter(item => item.typeid == categorieTypeId)
        .map(item => item.nametha)
        .toString()
    },
    filterPageName(pageId) {
      return this.pages
        .filter(item => item.idx == pageId)
        .map(item => item.name)
        .toString()
    },
    filterRegionName(regionId) {
      return this.regions
        .filter(item => item.idx == regionId)
        .map(item => item.nametha)
        .toString()
    }
  }
}
</script>

<style lang="scss" scoped></style>
